import {merge, cloneDeep} from 'lodash';
import en from './en.json';
import ru from './ru.json';

export default {
    en,
    ru: merge(cloneDeep(en), ru)
}
